import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "@fontsource-variable/inter"
import "@fontsource-variable/ibm-plex-sans"
import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/600.css"

import { Aplicacao } from "./Aplicacao"
import { aparenciaGuardada, aplicarAparencia } from "./preferencias"

import "./estilo/base.css"
import "./estilo/compatibilidade.css"
import "./estilo/temas.css"
import "./estilo/aparencia.css"

aplicarAparencia(aparenciaGuardada())

const raiz = document.getElementById("raiz")
if (!raiz) throw new Error("elemento #raiz nao encontrado em index.html")

createRoot(raiz).render(
  <StrictMode>
    <Aplicacao />
  </StrictMode>,
)
